import { render, staticRenderFns } from "./dealerDetail.vue?vue&type=template&id=f43ff6d6&scoped=true&"
import script from "./dealerDetail.vue?vue&type=script&lang=js&"
export * from "./dealerDetail.vue?vue&type=script&lang=js&"
import style0 from "./dealerDetail.vue?vue&type=style&index=0&id=f43ff6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43ff6d6",
  null
  
)

export default component.exports